import Wrapper from "@/components/pages/Wrapper.vue";
import ExamsOverall from "@/components/pages/exam-analytics/exams-overall/ExamsOverall.vue";
import AnswerSheetList from "@/components/pages/exam-analytics/answer-sheet-list/AnswerSheetList.vue";
import ExamInsight from "@/components/pages/exam-analytics/exam-insight/ExamInsight.vue";
import ExamsDetails from "@/components/pages/exam-analytics/exams-details/ExamsDetails.vue";
import ExamTakerDetails from "@/components/pages/exam-analytics/exam-taker-details/ExamTakerDetails.vue";

export default [
  {
    path: "/:company/exam-analytics",
    component: Wrapper,
    meta: {
      authRequired: true
    },
    children: [
      {
        name: "analytics-overall-exams",
        meta: { access: { menu: "exam", subMenu: ["exam-overview", "exam-answersheet"] } },
        path: "overall-exam",
        component: ExamsOverall
      },
      {
        name: "analytics-answer-sheet-list",
        meta: { access: { menu: "exam", subMenu: ["exam-overview", "exam-answersheet"] } },
        path: "answer-sheets",
        component: AnswerSheetList
      },
      {
        name: "analytics-exam-insight",
        meta: { access: { menu: "exam", subMenu: ["exam-overview", "exam-answersheet"] } },
        path: "exam-insight/:examId",
        component: ExamInsight,
        props: true
      },
      {
        name: "analytics-exams-details",
        meta: { access: { menu: "exam", subMenu: ["exam-overview", "exam-answersheet"] } },
        path: "exams-details",
        component: ExamsDetails
      },
      {
        name: "analytics-exam-taker-details",
        meta: { access: { menu: "exam", subMenu: ["exam-overview", "exam-answersheet"] } },
        path: "exam-taker-details/:id",
        props: true,
        component: ExamTakerDetails
      }
    ]
  }
];
